import script from "./DoctorDetailsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoctorDetailsView.vue?vue&type=script&lang=ts&setup=true"

import "./DoctorDetailsView.vue?vue&type=style&index=0&id=739f9185&lang=scss"

const __exports__ = script;

export default __exports__